import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-227a183c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "asset-overview" }
const _hoisted_2 = { class: "asset-table-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "stock-info"
}
const _hoisted_4 = { class: "stock-name" }
const _hoisted_5 = { class: "stock-code-row" }
const _hoisted_6 = { class: "stock-code" }
const _hoisted_7 = {
  key: 1,
  class: "summary-label"
}
const _hoisted_8 = { class: "two-lines" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "现价/成本", -1))
const _hoisted_10 = { class: "two-lines" }
const _hoisted_11 = { class: "detail-panel-wrapper" }
const _hoisted_12 = { class: "detail-content" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "detail-title" }, "持仓明细", -1))
const _hoisted_14 = { class: "account-info" }
const _hoisted_15 = { class: "account-id" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "成本价", -1))
const _hoisted_17 = {
  key: 0,
  class: "action-buttons"
}

import { ref, computed, nextTick, watch } from 'vue'
import { useRouter } from 'vue-router'
import { numFormat } from '@/utils/num_format'
import Decimal from 'decimal.js'
import { useCommonInfo } from '@/hooks/common'
import { ElMessageBox } from 'element-plus'

interface PositionRow {
  clientid: string
  fundAccount: string
  stockCode: string
  stockName: string
  stockNameGb: string
  exchangeType: string
  enableAmount: number
  currentAmount: number
  marketValue: number
  costPrice: number
  currentPriceDisplay: string
  incomeBalance: number
  moneyType: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AssetOverview',
  props: {
    lpoaPositionListData: null,
    lpoaFundInfoListData: null,
    accList: null
  },
  setup(__props: any) {

const props = __props as {
  lpoaPositionListData?: any[]
  lpoaFundInfoListData?: any[]
  accList?: any[]
};

const router = useRouter()



const { moneyType, exchangeRate } = useCommonInfo()

// HKD 原始值按当前币种汇率换算
const convertByRate = (hkdVal: number): number => {
  if (moneyType.value === 'HKD') return hkdVal
  return new Decimal(hkdVal).div(exchangeRate.value).toNumber()
}

const activeRowIndex = ref(0)
const showDetail = ref(false)
const detailPanelHeight = ref(0)
const activeRowCenterY = ref(0)
const stockAreaBottom = ref(0)

// accList -> account:name 映射
const nameMap = computed(() => {
  const map = new Map<string, string>()
  if (!props.accList?.length) return map
  props.accList.forEach((item: any) => {
    if (item.bindInfo) {
      item.bindInfo.forEach((bind: any) => {
        const name = bind.nameCn || [bind.englishFirstname, bind.englishLastname].filter(Boolean).join(' ')
        if (bind.account && name) map.set(bind.account, name)
      })
    }
  })
  return map
})

// 收集所有 client 的持仓行，标记 clientid
const allPositions = computed<PositionRow[]>(() => {
  const list: PositionRow[] = []
  if (!props.lpoaPositionListData?.length) return list

  const pushRow = (clientid: string, row: any) => {
    list.push({
      clientid,
      fundAccount: row.fundAccount || clientid,
      stockCode: row.stockCode,
      stockName: row.stockName || '',
      stockNameGb: row.stockNameGb || '',
      exchangeType: row.exchangeType || '',
      enableAmount: Number(row.enableAmount) || 0,
      currentAmount: Number(row.currentAmount) || 0,
      marketValue: Number(row.marketValueHkd) || 0,
      costPrice: Number(row.costPrice) || 0,
      currentPriceDisplay: row.currentPriceDisplay || '--',
      incomeBalance: Number(row.incomeBalance) || 0,
      moneyType: row.moneyType || ''
    })
  }

  props.lpoaPositionListData.forEach((client: any) => {
    const cid = client.clientid
    if (client.info && client.info.rows) {
      client.info.rows.forEach((row: any) => pushRow(cid, row))
    }
    // if (client.extPosInfo) {
    //   client.extPosInfo.forEach((ext: any) => {
    //     if (ext.extPositionInfo && ext.extPositionInfo.rows) {
    //       ext.extPositionInfo.rows.forEach((row: any) => pushRow(cid, row))
    //     }
    //   })
    // }
  })

  return list
})

// 现金市值：lpoaFundInfoListData 每个 item.fetchBalance 累加
const cashMarketValue = computed(() => {
  if (!props.lpoaFundInfoListData?.length) return 0
  return props.lpoaFundInfoListData.reduce(
    (s: number, item: any) => new Decimal(s).plus(Number(item.fetchBalance) || 0).toNumber(), 0
  )
})

// 按 stockCode 分组，聚合为左侧表格数据（含现金行 + 总计行）
const groupedTableData = computed(() => {
  const map = new Map<string, PositionRow[]>()
  allPositions.value.forEach(pos => {
    const arr = map.get(pos.stockCode)
    if (arr) arr.push(pos)
    else map.set(pos.stockCode, [pos])
  })

  const stockMV = allPositions.value.reduce((s, p) => s + p.marketValue, 0)
  const totalMV = new Decimal(stockMV).plus(cashMarketValue.value).toNumber()

  const result: any[] = []
  map.forEach((positions, stockCode) => {
    const first = positions[0]
    const enableAmount = positions.reduce((s, p) => s + p.enableAmount, 0)
    const currentAmount = positions.reduce((s, p) => s + p.currentAmount, 0)
    const marketValue = positions.reduce((s, p) => s + p.marketValue, 0)
    const incomeBalance = positions.reduce((s, p) => s + p.incomeBalance, 0)

    const totalCost = positions.reduce((s, p) => new Decimal(s).plus(new Decimal(p.costPrice).mul(p.currentAmount)).toNumber(), 0)
    const avgCost = currentAmount > 0 ? new Decimal(totalCost).div(currentAmount).toNumber() : 0

    const percent = totalMV > 0
      ? new Decimal(marketValue).div(totalMV).mul(100).toFixed(2, Decimal.ROUND_DOWN) + '%'
      : '--'

    result.push({
      stockCode,
      stockName: TRADABLE_EXCHANGES.includes(first.exchangeType?.toUpperCase()) ? first.stockNameGb : first.stockName,
      exchangeType: first.exchangeType,
      enablePos: numFormat(enableAmount, -1),
      currentPos: numFormat(currentAmount, -1),
      marketVal: numFormat(convertByRate(marketValue), 2),
      currentPrice: first.currentPriceDisplay,
      costPrice: numFormat(avgCost, 3),
      profit: numFormat(incomeBalance, 2),
      percent,
      _positions: positions,
      _rowType: 'stock'
    })
  })

  const cashPercent = totalMV > 0
    ? new Decimal(cashMarketValue.value).div(totalMV).mul(100).toFixed(2, Decimal.ROUND_DOWN) + '%'
    : '--'

  result.push({
    stockCode: '__cash__',
    stockName: '现金',
    exchangeType: '',
    enablePos: '--',
    currentPos: '--',
    marketVal: numFormat(convertByRate(cashMarketValue.value), 2),
    currentPrice: '--',
    costPrice: '--',
    profit: '--',
    percent: cashPercent,
    _positions: [],
    _rowType: 'cash'
  })

  const totalEnableAmount = allPositions.value.reduce((s, p) => s + p.enableAmount, 0)
  const totalCurrentAmount = allPositions.value.reduce((s, p) => s + p.currentAmount, 0)
  const totalIncomeBalance = allPositions.value.reduce((s, p) => s + p.incomeBalance, 0)

  result.push({
    stockCode: '__total__',
    stockName: '总计',
    exchangeType: '',
    enablePos: numFormat(totalEnableAmount, -1),
    currentPos: numFormat(totalCurrentAmount, -1),
    marketVal: numFormat(convertByRate(totalMV), 2),
    currentPrice: '--',
    costPrice: '--',
    profit: numFormat(totalIncomeBalance, 2),
    percent: '100%',
    _positions: [],
    _rowType: 'total'
  })

  return result
})

// 右侧详情：选中股票对应的各 client 持仓明细
const detailTableData = computed(() => {
  const selected = groupedTableData.value[activeRowIndex.value]
  if (!selected) return []

  return selected._positions.map((pos: PositionRow) => {
    const name = nameMap.value.get(pos.fundAccount) || nameMap.value.get(pos.clientid) || pos.clientid
    return {
      name,
      account: pos.fundAccount || pos.clientid,
      positionCount: numFormat(pos.currentAmount, -1),
      costPrice: numFormat(pos.costPrice, 3),
      profit: numFormat(pos.incomeBalance, 2),
      profitClass: pos.incomeBalance >= 0 ? 'profit-up' : 'profit-down'
    }
  })
})

const TRADABLE_EXCHANGES = ['SZ', 'SH', 'US', 'HK']
const showTradeButtons = computed(() => {
  const selected = groupedTableData.value[activeRowIndex.value]
  if (!selected) return false
  return TRADABLE_EXCHANGES.includes(selected.exchangeType?.toUpperCase())
})

// 右侧总盈亏
const totalProfit = computed(() => {
  const selected = groupedTableData.value[activeRowIndex.value]
  if (!selected) return '--'
  const sum = selected._positions.reduce((s: number, p: PositionRow) => s + p.incomeBalance, 0)
  return numFormat(sum, 2)
})

const tableRowClassName = ({ row, rowIndex }: { row: any, rowIndex: number }) => {
  if (row._rowType === 'cash' || row._rowType === 'total') return 'row-summary'
  return rowIndex === activeRowIndex.value ? 'row-active' : ''
}

// 从 DOM 测量真实位置
const measurePositions = () => {
  nextTick(() => {
    const wrapper = document.querySelector('.asset-table-wrapper') as HTMLElement
    if (!wrapper) return
    const wrapperTop = wrapper.getBoundingClientRect().top

    const rows = wrapper.querySelectorAll('.el-table__body tbody tr')
    if (!rows.length) return

    // 当前选中行的中心 Y
    const activeRow = rows[activeRowIndex.value] as HTMLElement
    if (activeRow) {
      const rect = activeRow.getBoundingClientRect()
      activeRowCenterY.value = rect.top - wrapperTop + rect.height / 2
    }

    // 最后一个股票行的底部（用于限制面板范围）
    const stockCount = groupedTableData.value.filter(r => r._rowType === 'stock').length
    if (stockCount > 0 && rows[stockCount - 1]) {
      const lastRect = (rows[stockCount - 1] as HTMLElement).getBoundingClientRect()
      stockAreaBottom.value = lastRect.bottom - wrapperTop
    }

    // 面板高度
    const panelEl = document.querySelector('.detail-panel') as HTMLElement
    if (panelEl) detailPanelHeight.value = panelEl.offsetHeight
  })
}

const arrowTop = computed(() => {
  return activeRowCenterY.value - 15
})

const panelOffsetY = computed(() => {
  const areaH = stockAreaBottom.value
  const panelH = detailPanelHeight.value || 300
  if (!areaH || panelH >= areaH) return 0
  let offset = activeRowCenterY.value - panelH / 2
  offset = Math.max(0, offset)
  offset = Math.min(offset, areaH - panelH)
  return offset
})

const handleRowClick = (row: any) => {
  if (row._rowType === 'cash' || row._rowType === 'total') return
  const index = groupedTableData.value.findIndex(item => item.stockCode === row.stockCode)
  if (index < 0) return
  activeRowIndex.value = index
  if (!showDetail.value) showDetail.value = true
  measurePositions()
}

const buildBidAskList = () => {
  const selected = groupedTableData.value[activeRowIndex.value]
  if (!selected || !selected._positions?.length) return []
  return selected._positions.map((pos: PositionRow) => ({
    fundAccount: pos.fundAccount || pos.clientid,
    stockCode: selected.stockCode,
    exchangeType: selected.exchangeType,
    entrustPrice: pos.currentPriceDisplay,
    stockNameGb: pos.stockNameGb || pos.stockName
  }))
}

const handleBuy = () => {
  const arr = buildBidAskList()
  if (!arr.length) return
  router.push({
    name: 'BulkTrading',
    params: { bidAskList: JSON.stringify(arr) }
  })
}

const handleSell = () => {
  const arr = buildBidAskList()
  if (!arr.length) return
  router.push({
    name: 'BulkTrading',
    params: { bidAskList: JSON.stringify(arr) }
  })
}

const handleTipClick = () => {
  ElMessageBox.alert('「成本价」仅供参考，成本价=（买入前的平均成本价x数量+此次买入的价格数x数量）/买入后持有数量。阁下任何依赖或就该数据所作的任何决定，金马证券概不负责。若需查询实际「成本价」，请电邮至cs@goldhorse.com.hk。', '免责声明', {
    confirmButtonText: '我知道了',
    customClass: 'message-info',
    showClose: false,
    center: true
  })
}

// 数据加载后自动展示第一行详情（以实际持仓为准，避免仅有现金/总计行时也展开）
watch(groupedTableData, () => {
  if (allPositions.value.length > 0) {
    showDetail.value = true
    activeRowIndex.value = 0
    measurePositions()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_table, {
        data: _unref(groupedTableData),
        "row-class-name": tableRowClassName,
        "show-header": true,
        onRowClick: handleRowClick,
        "highlight-current-row": "",
        class: "left-table"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "名称/代码",
            "min-width": "140"
          }, {
            default: _withCtx(({ row }) => [
              (row._rowType === 'stock')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(row.stockName), 1),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(row.stockCode), 1),
                      (TRADABLE_EXCHANGES.includes(row.exchangeType?.toUpperCase()))
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(["exchange-tag", 'tag-' + row.exchangeType.toLowerCase()])
                          }, _toDisplayString(row.exchangeType), 3))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(row.stockName), 1))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "可用/持仓",
            "min-width": "100",
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString(row.enablePos), 1),
                _createElementVNode("span", null, _toDisplayString(row.currentPos), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "marketVal",
            label: "市值",
            "min-width": "120",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "现价/成本",
            "min-width": "130",
            align: "center"
          }, {
            header: _withCtx(() => [
              _hoisted_9,
              _createElementVNode("i", {
                class: "info-icon",
                onClick: handleTipClick
              })
            ]),
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", null, _toDisplayString(row.currentPrice), 1),
                _createElementVNode("span", null, _toDisplayString(row.costPrice), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "percent",
            label: "仓位占比",
            "min-width": "100",
            align: "center"
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _withDirectives(_createElementVNode("div", {
        class: "popover-arrow",
        style: _normalizeStyle({ transform: 'translateY(' + _unref(arrowTop) + 'px)' })
      }, null, 4), [
        [_vShow, showDetail.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_Transition, { name: "slide-fade" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", {
            class: "detail-panel",
            style: _normalizeStyle({ transform: 'translateY(' + _unref(panelOffsetY) + 'px)' })
          }, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_el_table, {
                data: _unref(detailTableData),
                "show-header": true,
                class: "detail-table"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "姓名/账户",
                    "min-width": "130",
                    align: "center"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("span", null, _toDisplayString(row.name), 1),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(row.account), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "positionCount",
                    label: "持仓数量",
                    "min-width": "80",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "成本价",
                    "min-width": "80",
                    align: "center"
                  }, {
                    header: _withCtx(() => [
                      _hoisted_16,
                      _createElementVNode("i", {
                        class: "info-icon",
                        onClick: handleTipClick
                      })
                    ]),
                    default: _withCtx(({ row }) => [
                      _createElementVNode("span", null, _toDisplayString(row.costPrice), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"]),
              (_unref(showTradeButtons))
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("button", {
                      class: "btn-buy",
                      onClick: handleBuy
                    }, "买入"),
                    _createElementVNode("button", {
                      class: "btn-sell",
                      onClick: handleSell
                    }, "卖出")
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 4), [
            [_vShow, showDetail.value]
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})